/**
 * Route names defined for routes that only organizer user type can access.
 */
export const theaterOrganizerRouteNames = {
  organizationsTheater: 'theater-organizations',
  createOrganizationTheater: 'theater-create-organization',
  eventInfoTheater: 'theater-event-info',
  eventWorkersTheater: 'theater-event-workers',
  eventCategoriesTheater: 'theater-event-categories',
  theaterPerformance: 'theater-performance',
  accreditationsTheater: 'theater-accreditations',
  requestsTheater: 'theater-requests',
  createAccreditationTheater: 'theater-create-accreditation',
  editAccreditationTheater: 'theater-update-accreditation',
  eventDashboardTheater: 'theater-event-dashboard',
  theaterFloorPlanOverview: 'theater-floor-plan-overview',
  accreditationBuilderTheater: 'builder-accreditation-theater',
  visitorStatisticsTheater: 'theater-visitor-stats-container',
  scannedTicketsTheater: 'theater-scanned-tickets-container',
  inviteAttendeeTheater: 'theater-invite-attendee',
  attendeeFieldsTheater: 'theater-attendee-fields',
  eventConferenceDataTheater: 'event-conference-data-theater',
  scanEntriesTheater: 'scan-entries-theater',
  importExportTheater: 'theater-import-export',
  importTheater: 'theater-import',
  exportTheater: 'theater-export',
  eventAnnouncementsTheater: 'event-announcements-theater',
  newAnnouncementTheater: 'new-announcements-theater',
  displayAnnouncementTheater: 'display-announcement-theater',
  eventTranslateTheater: 'event-translate-theater',
  eventHallsTheater: 'event-halls-theater',
  newHallTheater: 'new-halls-theater',
  updateHallTheater: 'update-halls-theater',
  editInviteTheater: 'theater-invite-edit-container',
  emailsTheater: 'theater-emails',
  createEmailTheater: 'theater-create-email',
  emailDetailsTheater: 'theater-email-details',
  updateEmailTheater: 'theater-update-email',
  eventWorkshopsTheater: 'event-workshops-theater',
  newWorkshopTheater: 'new-workshops-theater',
  updateWorkshopTheater: 'update-workshops-theater',
  ticketsTheater: 'theater-tickets',
  promoCodesTheater: 'theater-promo-codes',
  visitorAnalyticsTheater: 'visitor-analytics-theater',
  addTicketTheater: 'theater-add-ticket',
  createEventTheater: 'theater-create-event',
  editTicketTheater: 'edit-ticket-theater',
  createTicketTheater: 'create-ticket-theater',
  eventsTheater: 'theater-events',
  floorPlanTheater: 'theater-floor-plan',
  inviteTheater: 'theater-invite',
  createTrialAccountTheater: 'theater-create-trial-account',
  successfulPaymentTheater: 'theater-successful-payment',
  customSuccessfulPaymentTheater: 'theater-custom-successful-payment',
}

export const theaterOrganizationRouteNames = {
  theaterOrganizationEvents: 'theater-organization-events',
  theaterLiveEvents: 'theater-organization-live-events',
  theaterPastEvents: 'theater-organization-past-events',
  theaterOrganizationAddEvent: 'theater-organization-add-event',
  theaterOrganizationProfileInfo: 'theater-organization-profile-info',
  theaterOrganizationTicketType: 'theater-organization-ticket-type',
  theaterOrganizationMailingList: 'theater-organization-mailing-list',
  theaterOrganizationFinanceInfo: 'theater-organization-finance-info',
  theaterOrganizationSubscribers: 'theater-organization-subscribers',
  theaterOrganizationGenres: 'theater-organization-genres',
  theaterOrganizationTags: 'theater-organization-tags',
  theaterOrganizationSubscriptionsPlan: 'theater-organization-subscription-plan',
  theaterOrganizationSubscriptionsList: 'theater-organization-subscription-list',
  theaterOrganizationMemberships: 'theater-organization-memberships',
  theaterOrganizationMembersList: 'theater-organization-members-list',
  theaterOrganizationReports: 'theater-organization-reports',
  theaterOrganizationPromoCodes: 'theater-organization-promo-codes',
  theaterOrganizationPromoCodeInfo: 'theater-organization-promo-code-info',
}
